import React, { useEffect, useState } from 'react';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { useUserUUID } from '@annunciate/core';
import { BasicNavItem } from './BasicNavItem';
import { DropdownNavItem } from './DropdownNavItem';
export const NavItem = ({ node: { name, link, children, authenticationStates, openInNewTab }, as: Item = BasicNavItem, onNavigate = () => { }, }) => {
    const uuid = useUserUUID();
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    useEffect(() => {
        setIsAuthenticated(!!uuid);
    }, [uuid]);
    const { authenticated, unauthenticated } = authenticationStates || {};
    if ((isAuthenticated && authenticated === false) ||
        (!isAuthenticated && unauthenticated === false)) {
        return null;
    }
    if (children && children.length > 0) {
        const slugish = name.toLocaleLowerCase().replace(/[^a-z]*/g, '');
        return (React.createElement(NavDropdown, { title: name, id: `nav-dropdown-${slugish}` }, children.map((node, i) => (React.createElement(NavItem, { node: node, as: DropdownNavItem, key: i, onNavigate: onNavigate })))));
    }
    else if (link) {
        return (React.createElement(Item, { name: name, link: link, openInNewTab: openInNewTab, onNavigate: onNavigate }));
    }
    else {
        return null;
    }
};
//# sourceMappingURL=NavItem.js.map